import { useAnalysisTargetListApi } from '@/common/api/modules/mediaAnalysisTarget'
import { useFirstLoading } from '@/common/api/search'
import { analysisTargetNewPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Text from '@/components/view/atoms/text/Text'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge, { AppTitleBadgeType } from '@/components/container/layout/AppTitleBadge'
import AnalysisTargetListTable from '@/components/container/modules/media/analysisTarget/table/AnalysisTargetListTable'

const AnalysisTargetListPage = () => {
  const siteId = useSiteId()
  const { data, isLoading, mutate } = useAnalysisTargetListApi({ site_id: siteId })
  const isFirstLoading = useFirstLoading(isLoading)

  return (
    <Main type={MainLayoutType.SMALL} bottomSpace>
      <PageTitle
        title={'分析対象一覧'}
        rightNode={
          <Button
            link={analysisTargetNewPath(siteId)}
            size='large'
            color={ButtonColor.PRIMARY_BRAND}
          >
            分析対象サイトを追加する
          </Button>
        }
        behindNode={data && <Text size={12}>{data.length}件</Text>}
        badgeNode={<AppTitleBadge type={AppTitleBadgeType.MEDIA} />}
      />
      <Content>
        {isFirstLoading ? (
          <Area tableWrap noBorder>
            <PageListLoading />
          </Area>
        ) : data && data.length > 0 ? (
          <AnalysisTargetListTable targets={data} onRefresh={mutate} />
        ) : (
          <Area tableWrap noBorder>
            <NoResultGuidance name='分析対象' />
          </Area>
        )}
      </Content>
    </Main>
  )
}

export default AnalysisTargetListPage
